const base64js = require('base64-js');

/* @ngInject */
export default class FinancialSummaryCtrl {
    constructor(
        $scope,
        $state,
        Utility,
        $timeout,
        $rootScope,
        BuildingsService,
        FinancialsService,
        LocalStorageService,
        NotificationService,
        AuthorizationService,
        FinancialSummaryService
    ) {
        this.$scope = $scope;
        this.$state = $state;
        this.Utility = Utility;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.BuildingsService = BuildingsService;
        this.FinancialsService = FinancialsService;
        this.LocalStorageService = LocalStorageService;
        this.NotificationService = NotificationService;
        this.AuthorizationService = AuthorizationService;
        this.FinancialSummaryService = FinancialSummaryService;

        this.init();
        this.activate(true);
    }

    async activate(isInit = false) {
        let { date } = this.$state.params;
        if (date) {
            this.navigateDate = moment(date, 'YYYY/MM/DD').add(3, 'h');
        }
        this.selectedBuildingRef = this.BuildingsService.getSelectedBuildingRef();
        let buildingName = '';
        const userProfile = this.LocalStorageService.retrieve('userProfile');

        if (userProfile) {
            if (!!!this.selectedBuildingRef) {
                this.selectedBuildingRef = userProfile.BuildingProfiles[0].SchemeReference;
            }

            const selectedBuilding = userProfile.BuildingProfiles.find((building) => {
                return building.SchemeReference.toUpperCase().trim() === this.selectedBuildingRef.toUpperCase().trim();
            });

            if (selectedBuilding) {
                buildingName = selectedBuilding.SchemeName;
            }
        }
        this.selectedBuildingName = buildingName;
        await this.getbuildingWorkflowAndFeatures();
        await this.getFinancialYears(isInit);
        
        this.dateLastReportMonth = await this.FinancialsService.getLastFinancialMonth(this.selectedBuildingRef);
        if (this.navigateDate)
        {
            this.filterDate = this.Utility.getFormatedDate(this.navigateDate);
        }
        else {
            this.filterDate = this.Utility.getFormatedDate(this.dateLastReportMonth);
        }
        
        if (!this.navigateDate) {
            var yearsAmount = this.FinancialsService.financialYears.length;
            var whenFrom2 = this.FinancialsService.financialYears;
            for (var x = yearsAmount - 1; x >= 0; x--) {
                if (this.dateLastReportMonth >= whenFrom2[x].WhenFrom && this.dateLastReportMonth <= whenFrom2[x].WhenTo) {
                    this.filterYear = whenFrom2[x].WhenTo;
                    var temp = this.filterYear;
                    var temp2 = this.Utility.getFormatedDate(temp);
                    await this.getFinancialMonths(temp2, isInit);
                }
            }
        }
        else {
            await this.getFinancialMonths(this.Utility.getFormatedDate(this.navigateDate), isInit);
        }
        this.filterMonth = this.filterDate;
        if (!!this.filterMonth) {
            await this.getFinancialSummary();
        }
        this.saveSelectedDate();
        if (!this.navigateDate) {
            $('#filter-month option[value="string:' + this.dateLastReportMonth + '"]').attr('selected', true);
        }
        else {
            var temp = new Date(this.navigateDate);
            var navDate = new Date(temp.setHours(2, 0, 0));
            navDate = navDate.toISOString();
            navDate = navDate.slice(0, -5);
            $('#filter-month option[value="string:' + navDate + '"]').attr('selected', true);
        }

    }

    init() {
        this.message = '';
        this.isInit = true;
        this.mailingList = {
            emails: [],
            schemeRef: null,
            isLoading: false
        };
        this.selectedEmailListItems = [];

        this.editedEmails = [];
        this.deletedEmails = [];

        this.isFilterActive = true;

        this.filterYear = undefined;
        this.filterMonth = undefined;

        this.selectedBuildingRef = '';
        this.navigateDate = undefined;        
        this.filterDate = undefined;
        this.dateLastReportMonth = undefined;
        this.selectedBuildingName = '';
        this._switchIsBusyLoading(false);
        this.today = this.Utility.getFormatedDate(new Date());

        this.$scope.$on('selected-building-changed', async (event, newValue) => {
            await this.onSelectedBuildingChanged(this, newValue);
        });

        this.activate(true);
    }

    async onSelectedBuildingChanged(event, schemeRef) {
        this._switchIsBusyLoading(true);
        if (schemeRef && schemeRef['length'] > 2) this.selectedBuildingRef = schemeRef;
        else this.selectedBuildingRef = this.BuildingsService.getSelectedBuildingRef();

        if (this.selectedBuildingRef && this.selectedBuildingRef.length > 2) {
            await this.activate();
        }
    }

    async filterByMonth() {
        if (this.filterMonth !== '' && this.filterMonth) {
            await this.getFinancialSummary();
        } else {
            this.FinancialSummaryService.financialSummary = {};
        }
    }

    async filterByYear() {
        this.filterMonth = '';
        this.FinancialSummaryService.financialSummary = undefined;
        this.selectedDateYear = this.Utility.getFormatedDate(this.filterYear);
        await this.getFinancialMonths(this.selectedDateYear);
    }

    async getFinancialYears(isInit = false) {
        this._switchIsBusyLoading(true);

        try {
            let date = this.today;
            if (this.filterDate) {
                date = this.filterDate;
            }
            await this.FinancialsService.getFinancialYears(this.selectedBuildingRef, date);
            this.filterYear = this.FinancialsService.financialYears[
                this.FinancialsService.financialYears.length - 1
            ].WhenTo;

            await this.getFinancialMonths(date, isInit);
        } catch (err) {
            console.error(`Error while loading financial years: ${err}`);
        } finally {
            this._switchIsBusyLoading(false);
        }
    }

    async getFinancialMonths(date, isInit) {
        this._switchIsBusyLoading(true);
        if (date > this.today) {
            date = this.today;
        }

        try {
            await this.FinancialsService.getFinancialMonths(this.selectedBuildingRef, date);
            const lastDate = this.FinancialsService.financialMonths[this.FinancialsService.financialMonths.length - 1]
                .WhenFrom;
            if (isInit || this.filterDate) {
                this.filterMonth = lastDate;
            } else {
                this.filterMonth = '';
            }
            if (this.filterMonth) {
				await this.getFinancialSummary();
			}
        } catch (error) {
        } finally {
            this._switchIsBusyLoading(false);
        }
    }

    async downloadAllAttachments(onlyLevyRoll) {
        const modalSelector = '#gettingDocuments';
        const modalTimeout = 50;

        this.isBusyFetchingDocuments = true;
        this.$timeout(() => {
            angular.element(modalSelector).modal('show');
        }, modalTimeout);

        const date = this.Utility.getFormatedDate(this.filterMonth);
        let zipFileResult = await this.FinancialSummaryService.downloadAllAttachments(date, onlyLevyRoll);

        let zipFile = zipFileResult.data.Data;

        var zipBytes = base64js.toByteArray(zipFile.FileBytes);

        let contentType = 'application/zip';
        let urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
        if (urlCreator) {
            let blob = new Blob([zipBytes], { type: contentType });
            let url = urlCreator.createObjectURL(blob);
            let a = document.createElement('a');
            document.body.appendChild(a);
            a.style = 'display: none';
            a.href = url;
            a.download = `${zipFile.Name}${zipFile.Extension}`;

            this.isBusyFetchingDocuments = false;

            a.click();
            window.URL.revokeObjectURL(url);
            a.remove();

            this.$timeout(() => {
                angular.element(modalSelector).modal('hide');
            }, modalTimeout);
        }
    }

    async getAllReports() {
        this._switchIsBusyLoading(true);

        try {
            const date = this.Utility.getFormatedDate(this.filterMonth);
            this.reportModelHeader = `${this.selectedBuildingName} - Cashflow Statement - ${moment(
                date
            ).format('MMM YYYY')}`;
            await this.FinancialsService.getAllReports(
                this.selectedBuildingRef,
                date,
                0,
                this.reportModelHeader
            );


        } catch (err) {
            this.NotificationService.error('Error Downloading Report');
        }

        finally {
            this._switchIsBusyLoading(false);
        }
    }

    async getFinancialSummary() {
        this._switchIsBusyLoading(true);

        try {
            const date = this.Utility.getFormatedDate(this.filterMonth);
            await this.FinancialSummaryService.getFinancialSummary(this.selectedBuildingRef, date);
            const { Message } = this.FinancialSummaryService.financialSummary;

            this.message = Message;
        } catch (error) {
            this.NotificationService.error('Error loading Financial Summary');
        } finally {
            this._switchIsBusyLoading(false);
        }
        var twatyear = this.FinancialsService.financialYears[this.FinancialsService.financialYears.length - 1];
        var twatmonth = this.FinancialsService.financialMonths[this.FinancialsService.financialMonths.length - 1];
        //$('#filter-year option[value="string:' + twatyear.WhenTo + '"]').attr('selected', true);

    }

    async gotoOldFinancials() {
        const date = moment(this.filterMonth).format('MMM YYYY');
        let nav = `Monthly Financial Statements>${date}`;
        let isItFinancialsSection = true;
        nav = encodeURI(nav);
        this.$state.go('documents', { isItFinancialsSection, nav });
    }

    async getFinancialSummaryAttachment(id) {
        this._switchIsBusyLoading(true);
        try {
            await this.FinancialSummaryService.getFinancialSummaryAttachment(id);
        } catch (error) {
        } finally {
            this._switchIsBusyLoading(false);
        }
    }

    async preApprove() {
        this.editedEmails = [];
        this.deletedEmails = [];

        this.$timeout(async () => {
            angular.element('#mailingList').modal('show');
            await this.loadEmails();
        });
    }

    async approve() {
        this._switchIsBusyLoading(true);

        try {
            const payload = this._serverfyFinancialSummary();
            await this.FinancialSummaryService.approve(payload);
            this.NotificationService.success('Approved Successfully');
            await this.getFinancialSummary();
        } catch (error) {
            console.error(error);
            this.NotificationService.error('Could Not Accept');
        } finally {
            this._switchIsBusyLoading(false);
        }
    }

    async bookkeeperApprove() {
        this._switchIsBusyLoading(true);

        try {
            const payload = this._serverfyFinancialSummary();
            await this.FinancialSummaryService.bookkeeperApprove(payload);
            this.NotificationService.success('Approved Successfully');
            await this.getFinancialSummary();
        } catch (error) {
            console.error(error);
            this.NotificationService.error('Could Not Accept');
        } finally {
            this._switchIsBusyLoading(false);
        }
    }

    async reject() {
        this._switchIsBusyLoading(true);

        try {
            await this.FinancialSummaryService.reject(this.rejectionReason, this.filterMonth);
            this.NotificationService.success('Rejected Successfully');
            await this.getFinancialSummary();
        } catch (error) {
            this.NotificationService.error('Could Not Reject');
            console.error(error);
        } finally {
            this._switchIsBusyLoading(false);
        }
    }

    async bookkeeperReject() {
        this._switchIsBusyLoading(true);

        try {
            await this.FinancialSummaryService.bookkeeperReject(this.rejectionReason, this.filterMonth);
            this.NotificationService.success('Rejected Successfully');
            await this.getFinancialSummary();
        } catch (error) {
            this.NotificationService.error('Could Not Reject');
            console.error(error);
        } finally {
            this._switchIsBusyLoading(false);
        }
    }

    async loadEmails() {
        this._switchMailingListLoading(true);

        try {
            var results = await this.FinancialSummaryService.getMailingList();
            const { EmailListItems, Id } = results;
            this.mailingList = {
                ...this.mailingList,
                TrusteeMailingListItems: EmailListItems.filter(x => { return x.IsTrustee == true; }),
                AdHocMailingListItems: EmailListItems.filter(x => { return x.IsTrustee == false; }),
                schemeRef: this.selectedBuildingRef,
                isEdit: false,
                Id: Id
            };
        } catch (error) {
            this.mailingList = {
                TrusteeMailingListItems: [],
                AdHocMailingListItems: [],
                isEdit: false,
                schemeRef: null,
                isLoading: false,
                Id: null
            };
            this.NotificationService.error('Error Fetching Mailing List.');
            console.error('Error Fetching Mailing List.', error);
        } finally {
            this._switchMailingListLoading(false);
        }
    }

    async addEmail() {
        this.mailingList.AdHocMailingListItems.push({
            isEdit: true,
            isDeleted: false,
            CommunicationChannel: '0',
            MailingListHeaderId: this.mailingList.Id,
            CommunicationChannelDescription: 'Email'
        });
    }

    async editEmail(id) {
        await this.editEmailCore(id, this.mailingList.AdHocMailingListItems);
    }

    async editTrusteeEmail(id) {
        await this.editEmailCore(id, this.mailingList.TrusteeMailingListItems);
    }


    async editEmailCore(id, mailingList) {
        let index = -1;
        mailingList.find((mail, i) => {
            if (mail.Id === id) {
                index = i;
                return true;
            }
            return false;
        });

        if (index > -1) {
            const email = this.editedEmails.find((mail) => mail.Id === id);
            if (!!!email) {
                const newEmail = { ...mailingList[index] };
                this.editedEmails = [...this.editedEmails, newEmail];

                mailingList[index].CommunicationChannel =
                    mailingList[index].CommunicationChannel + '';
                mailingList[index].isEdit = true;
            }
        }
    }

    deleteEmail(id) {
        let index = -1;

        const email = this.mailingList.AdHocMailingListItems.find((mail, i) => {
            if (mail.Id === id) {
                index = i;
                return true;
            }
            return false;
        });

        if (index > -1) {
            const newEmail = JSON.parse(JSON.stringify(this.mailingList.AdHocMailingListItems[index]));
            this.deletedEmails = [...this.deletedEmails, newEmail];
            this.mailingList.AdHocMailingListItems[index].isEdit = false;
            this.mailingList.AdHocMailingListItems[index].IsDeleted = true;

            const { UserName } = this.LocalStorageService.retrieve('userProfile');
            this.mailingList.AdHocMailingListItems[index].WhoActioned = UserName;
        }
    }

    cancelOutMailingList() {
        this.editedEmails.concat(this.deletedEmails).forEach((mail) => {
            let index = -1;
            const editedMail = this.mailingList.AdHocMailingListItems.find((x, i) => {
                if (x.Id === mail.Id) {
                    index = i;
                    return x;
                }
                return false;
            });

            if (!!editedMail) {
                this.mailingList.AdHocMailingListItems[index] = mail;
                this.editedEmails = this.editedEmails.filter((x) => x.Id !== mail.Id);
                this.deletedEmails = this.deletedEmails.filter((x) => x.Id !== mail.Id);
            }
        });
    }

    cancelEditEmail(id) {
        let index = -1;

        if (id && (id + '').includes('-')) {
            this.mailingList.AdHocMailingListItems.find((mail, i) => {
                if (mail.Id === id) {
                    index = i;
                    return true;
                }
                return false;
            });

            if (index > -1) {
                const email = this.editedEmails.find((mail, i) => mail.Id === id);
                this.mailingList.AdHocMailingListItems[index] = email;

                this.editedEmails = this.editedEmails.filter((mail) => mail.Id !== id);
            }
        } else {
            this.mailingList.AdHocMailingListItems.splice(id, 1);
        }
    }

    saveEmailCore(id, mailingList) {
        let index = -1;

        if (id && (id + '').includes('-')) {
            const email = mailingList.find((mail, i) => {
                if (mail.Id === id) {
                    index = i;
                    return true;
                }

                return false;
            });

            if (index > -1) {
                mailingList[index].isEdit = false;
                mailingList[index].IsDeleted = false;

                const { UserName } = this.LocalStorageService.retrieve('userProfile');
                mailingList[index].WhoActioned = UserName;
            }
        } else {
            index = id;
            mailingList[index].isEdit = false;
            mailingList[index].IsDeleted = false;

            const { UserName } = this.LocalStorageService.retrieve('userProfile');
            mailingList[index].WhoActioned = UserName;
        }

        mailingList[index].CommunicationChannelDescription =
            mailingList[index].CommunicationChannel === '0' ? 'PDFs' : 'Online';
    }

    saveEmail(id) {
        this.saveEmailCore(id, this.mailingList.AdHocMailingListItems);
    }

    saveTrusteeEmail(id) {
        this.saveEmailCore(id, this.mailingList.TrusteeMailingListItems);
    }

    async preSaveMailingList() {

        const { AdHocMailingListItems: AdHocMailingListItems, TrusteeMailingListItems: TrusteeMailingListItems } = this.mailingList;
        const selectedTrusteeMailingListItems = TrusteeMailingListItems.filter(x => { return x.include == true; });
        const selectedAdHocMailingListItems = AdHocMailingListItems.filter(x => { return x.IsDeleted == false; });
        this.selectedEmailListItems = [...selectedTrusteeMailingListItems, ...selectedAdHocMailingListItems];

        angular.element('#mailingList').modal('hide');

        this.$timeout(() => {
            angular.element('#confirm').modal('show');
        }, 500);
    }

    async saveMailingList() {
        this._switchMailingListLoading(true);

        try {
            const payload = this._serverfyMailingList();
            const results = await this.FinancialSummaryService.saveMailingList(payload);

            this.NotificationService.success('Mailing list saved.');
            angular.element('#mailingList').modal('hide');

            await this.approve();
        } catch (error) {
            const msg = 'Error saving mailing list.';
            console.error(msg, error);
            this.NotificationService.error(msg);
        } finally {
            this._switchMailingListLoading(false);
        }
    }

    async getbuildingWorkflowAndFeatures() {
        this._switchIsBusyLoading(true);
        try {
            await this.FinancialSummaryService.getbuildingWorkflowAndFeatures(this.selectedBuildingRef);
            var buildingWorkflowAndFeatures = this.FinancialSummaryService.buildingWorkflowAndFeatures;
            var hideLegacyDocuments = buildingWorkflowAndFeatures[0].Data.HideLegacyFinancialDocuments;            
            if (hideLegacyDocuments == true) {
                $('#legacyDocumentsFolder').hide();
            }
            else {
                $('#legacyDocumentsFolder').show();
            }
        } catch (err) {
            console.error(`Error while loading building workflow data: ${err}`);
        } finally {
            this._switchIsBusyLoading(false);
        }
    }

    get canApproveFinancials() {
        let isAllowed = this.AuthorizationService.isAuthorized('Approve Financial Summary') &&
            this.AuthorizationService.isAuthorized('Reject Financial Summary');

        try {

            if (this.FinancialSummaryService.financialSummary) {
                const { Date } = this.FinancialSummaryService.financialSummary;
                const momentDate = moment(Date);
                const year = momentDate.year() > 2017;
                isAllowed =
                    year &&
                    isAllowed &&
                    this.FinancialSummaryService &&
                    this.FinancialSummaryService.financialSummary &&
                    this.FinancialSummaryService.financialSummary.Status === 3;
            }
            else {
                isAllowed = false;
            }
        } catch (error) {
            isAllowed = false;
            console.error('Error while checking the "Approve Financials" claim');
        }

        return isAllowed;
    }

    get bookkeeperCanApproveFinancials() {
        let isAllowed = 
            this.AuthorizationService.isAuthorized('Bookkeeper Approve Financial Summary') &&
            this.AuthorizationService.isAuthorized('Bookkeeper Reject Financial Summary');

        try {

            if (this.FinancialSummaryService.financialSummary) {
                const { Date } = this.FinancialSummaryService.financialSummary;
                const momentDate = moment(Date);
                const year = momentDate.year() > 2017;
                isAllowed =
                    year &&
                    isAllowed &&
                    this.FinancialSummaryService &&
                    this.FinancialSummaryService.financialSummary &&
                    this.FinancialSummaryService.financialSummary.Status === 4;
            }
            else {
                isAllowed = false;
            }
        } catch (error) {
            isAllowed = false;
            console.error('Error while checking the "Approve Financials" claim');
        }

        return isAllowed;
    }

    get canRejectFinancials() {
        let isAllowed = this.AuthorizationService.isAuthorized('Reject Financial Summary');

        try {
            if (this.FinancialSummaryService.financialSummary) {
                const { Date } = this.FinancialSummaryService.financialSummary;
                const momentDate = moment(Date);
                const year = momentDate.year() > 2017;
                isAllowed =
                    year &&
                    isAllowed &&
                    this.FinancialSummaryService &&
                    this.FinancialSummaryService.financialSummary &&
                    this.FinancialSummaryService.financialSummary.Status === 3;
            }
            else {
                isAllowed = false;
            }
        } catch (error) {
            isAllowed = false;
            console.error('Error while checking the "Reject Financials" claim');
        }

        return isAllowed;
    }

    get isBuildingLogin() {
        let isBuilding =
            this.AuthorizationService.isAuthorized('Approve Financial Summary') &&
            this.AuthorizationService.isAuthorized('Reject Financial Summary');
        return isBuilding;
    }

    get hasSummary() {
        let flag =
            this.FinancialSummaryService.financialSummary && this.FinancialSummaryService.financialSummary.Summary;

        return flag;
    }

    allowAction(actionName) {
        return this.AuthorizationService.isAuthorized(actionName);
    }

    isDesktop() {
        this.LocalStorageService.save('mediaDevice', 'mobile');
        const mdvice = this.LocalStorageService.retrieve('mediaDevice');
        if (mdvice == 'mobile') {
            return true;
        }

        return false;
    }

    openFinancials(page) {
        this.saveSelectedDate();
        this.$rootScope.$broadcast('navigate-changed', page, { date: this.filterMonth });
    }

    async getReportCashAvailability() {
		this._switchIsBusyLoading(true);
        this.selectedDate = this.filterMonth;
		try {
			this.reportModelHeader = `${this.selectedBuildingName} - Cash Availability Report - ${moment(
				this.selectedDate
			).format('MMM YYYY')}`;
            this.saveSelectedDate();
			await this.FinancialsService.getReport(
				this.selectedBuildingRef,
				this.selectedDate,
				6,
				this.reportModelHeader
			);
		} catch (err) {
			this.NotificationService.error('Error Downloading Cash Availability Report');
		} finally {
			this._switchIsBusyLoading(false);
		}
	}

    saveSelectedDate() {
        const selectedYear = moment(this.filterYear).toDate();
        const selectedMonth = moment(this.filterMonth).add(3, 'h').toDate();
        this.LocalStorageService.save('selectedReportYear', selectedYear);
        this.LocalStorageService.save('selectedReportMonth', selectedMonth);
    }

    async printPreviewSummaryWriteUp() {
        //'{date}/RenderPdf'

        const date = moment(this.filterMonth).add(3, 'h');
        await this.FinancialSummaryService.printPreviewSummaryWriteUp(date);
    }

    _switchIsBusyLoading(flag) {
        this.$timeout(() => {
            this.isBusy = flag;
        });
    }

    _switchMailingListLoading(flag) {
        this.$timeout(() => {
            this.mailingList.isLoading = flag;
        });
    }

    _serverfyMailingList() {
        const { Id, AdHocMailingListItems: AdHocMailingListItems, TrusteeMailingListItems: TrusteeMailingListItems, schemeRef: SchemeReference } = this.mailingList;
        const selectedTrusteeMailingListItems = TrusteeMailingListItems.filter(x => { return x.include == true; });
        const selectedAdHocMailingListItems = AdHocMailingListItems.filter(x => { return x.IsDeleted == false; });
        const mapped = {
            Id,
            EmailListItems: [...selectedTrusteeMailingListItems, ...selectedAdHocMailingListItems],
            SchemeReference
        };

        for (let index = 0; index < mapped.EmailListItems.length; index++) {
             mapped.EmailListItems[index].HasBeenSent = false;
        }

        return mapped;
    }

    _serverfyFinancialSummary() {
        const ApprovalDate = moment(this.filterMonth).format('MM/DD/YYYY');
        const { IsNewProcess, SchemeReference } = this.FinancialSummaryService.financialSummary;
        const { UserName: WhoApproved } = this.LocalStorageService.retrieve('userProfile');

        const mapped = {
            WhoApproved,
            ApprovalDate,
            IsNewProcess,
            SchemeReference
        };

        return mapped;
    }

    async getAllReports(onlyLevyRoll) {
        this._switchIsBusyLoading(true);

        try {

            this.reportModelHeader = `${this.selectedBuildingName} - All Financial Reports Statement - ${moment(
                this.selectedDate
            ).format('MMM YYYY')}`;
            await this.FinancialsService.getAllReports(
                this.selectedBuildingRef,
                this.filterMonth,
                onlyLevyRoll,
                0,
                this.reportModelHeader
            );


        } catch (err) {
            this.NotificationService.error('Error Downloading Report');
        }

        finally {
            this._switchIsBusyLoading(false);
        }
    }
}
